<template>
  <div id="allMallSerch">
    <div style="background-color: #fff">
      <div style="width: 1300px; margin: auto">
        <div
          class="d_flex"
          style="height: 70px; justify-content: space-between; padding: 30px 0"
        >
          <div style="width: calc(18% - 40px)">
            <img
              @click="toIndex"
              src="../../assets/img/topLog2.png"
              class="c_p"
              width="232px"
            />
          </div>
          <div class="searchBlock d_flex">
            <!-- <input
              v-model="searchValue"
              @keydown.enter="toSearchPage"
              placeholder="请输入品名 规格 材质 钢厂等搜索 如 冷轧卷 1.0*1250"
              type="text"
            /> -->
            <input
              v-model="searchValue"
              @keydown.enter="toSearchPage"
              placeholder="请输入品名 规格等关键词搜索，多关键词以空格隔开"
              type="text"
            />
            <div class="c_p">
              <img
                @click="toSearchPage"
                style="height: 36px; width: 36px"
                src="../../assets/img/search.png"
              />
            </div>
          </div>
          <div class="p_r">
            <div v-if="!isRegister" class="cartDiv2">
              <i
                class="icon iconfont icongouwucheman"
                style="font-size: 20px"
              ></i>
              <span>我的购物车</span>
            </div>
            <div v-else @click="goOrder()" class="cartDiv">
              <i
                class="icon iconfont icongouwucheman"
                style="font-size: 20px"
              ></i>
              <span>我的购物车</span>
              <abbr class="NoWrap">{{ myShopList.length }}</abbr>
            </div>
            <section class="cartInfoDiv p_a" style="right: 0">
              <nav>
                <i
                  class="icon iconfont icongouwuche colorRede31d1a f_w"
                  style="font-size: 22px"
                ></i>
                <span>购物车</span>
              </nav>
              <div>
                <ul>
                  <li :key="index" v-for="(item, index) in myShopList">
                    <div class="CargoCard">
                      <div class="t_c" style="width: 30px">
                        <input
                          v-if="parseInt(item.delFlag) !== 1"
                          class="allCheckbox"
                          :id="'shopChecck' + index"
                          v-model="item.checked"
                          type="checkbox"
                        />
                        <label
                          v-if="parseInt(item.delFlag) !== 1"
                          :for="'shopChecck' + index"
                        ></label>
                      </div>
                      <div>
                        <img :src="item.masterImgUrl" />
                      </div>
                      <div>
                        <p class="NoWrap">
                          <span class="f_w">{{ item.name }}</span>
                          <span class="m_l_5"
                            >{{ item.shopGoodVO.materialQualityName || "-" }}
                            {{ item.shopGoodVO.guige || "-" }}</span
                          >
                          <span
                            v-if="parseInt(item.delFlag) !== 1"
                            style="float: right; margin-top: 2px"
                            >库存：{{ item.shopGoodVO.skuList[0].stock }}</span
                          >
                        </p>
                        <p class="colorGray696969 NoWrap">
                          <span>{{
                            item.shopGoodVO.originPlaceName || "-"
                          }}</span>
                          <span>
                            {{ item.shopGoodVO.warehouseName || "-" }}</span
                          >
                          <span v-if="item.shopGoodVO.lisuanWeight">
                            理重：{{ item.shopGoodVO.lisuanWeight }}</span
                          >
                          <span v-if="item.shopGoodVO.weight"
                            >个重：{{ item.shopGoodVO.weight }}</span
                          >
                        </p>
                        <div v-if="parseInt(item.delFlag) !== 1" class="d_flex">
                          <div class="font14 f_w">
                            <span v-if="item.shopGoodVO.lisuanPrice"
                              >理计：￥{{
                                parseFloat(
                                  item.shopGoodVO.lisuanPrice * item.amount
                                ).toFixed(2)
                              }}</span
                            >
                            <span v-if="item.shopGoodVO.price"
                              >磅计：￥{{
                                parseFloat(
                                  item.shopGoodVO.price * item.amount
                                ).toFixed(2)
                              }}</span
                            >
                          </div>
                          <div>
                            <span
                              style="user-select: none"
                              @click="countNum('reduce', item)"
                              class="cartGrid"
                              >-</span
                            >
                            <span class="cartInfoSpan">{{ item.amount }}</span>
                            <span
                              style="user-select: none"
                              @click="countNum('add', item)"
                              class="cartGrid"
                              >+</span
                            >
                          </div>
                        </div>
                        <div v-else>
                          <span class="font16 color888">已失效</span>
                        </div>
                      </div>
                    </div>
                    <div style="padding: 5px 20px">
                      <span class="cartInfoSpan colorBlue525CA3">{{
                        $commonJs.returnSelType(item.shopGoodVO.settlementType)
                      }}</span>
                      <span
                        @click="deleteShopCar(item)"
                        style="float: right; margin-top: 3px"
                        class="colorRed c_p"
                        >删除</span
                      >
                    </div>
                  </li>
                </ul>
              </div>
              <div>
                <div>
                  <p>
                    <span class="colorRede31d1a">{{ totalCount.number }}</span
                    ><span class="m_l_5">件商品</span>
                  </p>
                  <p>
                    <span>理计：</span>
                    <span class="colorRede31d1a f_w font16">{{
                      parseFloat(totalCount.lisuanWeight).toFixed(2)
                    }}</span
                    ><span> t</span>
                    <span class="colorRede31d1a"
                      ><span>￥</span
                      ><span class="font16 f_w">{{
                        parseFloat(totalCount.lisuanPrice).toFixed(2)
                      }}</span></span
                    >
                  </p>
                  <p>
                    <span>磅计：</span>
                    <span class="colorRede31d1a f_w font16">{{
                      parseFloat(totalCount.weight).toFixed(2)
                    }}</span
                    ><span> t</span>
                    <span class="colorRede31d1a"
                      ><span>￥</span
                      ><span class="font16 f_w">{{
                        parseFloat(totalCount.price).toFixed(2)
                      }}</span></span
                    >
                  </p>
                </div>
                <div
                  style="background-color: #999"
                  v-if="totalCount.number === 0"
                >
                  去购物车结算
                </div>
                <div @click="goOrder()" v-else>去购物车结算</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pubilshSet from '../../assets/js/pubilshSet'

export default {
  name: 'allMallSerch',
  props: [
    'nowPage',
    'isRefreshShopCar'
  ],
  data () {
    return {
      MemberInfo: JSON.parse(window.localStorage.getItem('MemberInfo') || '{}'),
      searchValue: '',
      isRegister: window.localStorage.getItem('memberId') || false,
      myShopList: []
    }
  },
  mounted: () => {
    console.log(this)
    window.addEventListener('storage', e => {
      if (e.key === 'memberId') {
        this.isRegister = window.localStorage.getItem('memberId') || false
      }
    })
  },
  watch: {
    'isRegister': () => {
      console.log('reg改变了')
      this.$forceUpdate()
    }
  },
  computed: {
    totalCount () {
      let total = {
        number: 0,
        price: 0,
        lisuanPrice: 0,
        lisuanWeight: 0,
        weight: 0
      }
      for (let i = 0; i < this.myShopList.length; i++) {
        if (this.myShopList[i].checked && parseInt(this.myShopList[i].delFlag) !== 1) {
          total.number++
          if (this.myShopList[i].shopGoodVO.settlementType === '3' || this.myShopList[i].shopGoodVO.settlementType === '1') {
            total.lisuanWeight += this.myShopList[i].shopGoodVO.lisuanWeight || 0
            total.lisuanPrice += (this.myShopList[i].shopGoodVO.lisuanPrice || 0) * this.myShopList[i].amount * this.myShopList[i].shopGoodVO.lisuanWeight
          }
          if (this.myShopList[i].shopGoodVO.settlementType === '3' || this.myShopList[i].shopGoodVO.settlementType === '2') {
            total.weight += this.myShopList[i].shopGoodVO.weight || 0
            total.price += (this.myShopList[i].shopGoodVO.price || 0) * this.myShopList[i].amount * this.myShopList[i].shopGoodVO.weight
          }
        }
      }
      return total
    }
  },
  created () {
    console.log(window.localStorage.getItem('memberId'))
    if (window.localStorage.getItem('memberId')) {
      this.getShopList()
    }
    if (this.$route.query.name) {
      this.searchValue = this.$route.query.name
    }
    console.log(this.isRefreshShopCar)
  },
  methods: {
    toIndex () {
      window.location.href = pubilshSet.searchHostUrl
    },
    toSearchPage () {
      if (!this.nowPage) {
        this.$router.push({
          name: 'index',
          query: {
            type: 'showXianhuo',
            text: this.searchValue
          }
        })
        location.reload()
      } else {
        this.$emit('initSearch', this.searchValue)
      }
    },
    goOrder () {
      // let orderList = []
      // let checkedList = []
      // for (let i = 0; i < this.myShopList.length; i++) {
      //   if (this.myShopList[i].checked) {
      //     checkedList.push(this.myShopList[i])
      //     orderList.push(this.myShopList[i])
      //   }
      // }
      // for (let i = 0; i < checkedList.length; i++) {
      //   if (checkedList[i - 1]) {
      //     if (checkedList[i].shopGoodVO.calculateMethod !== checkedList[i - 1].shopGoodVO.calculateMethod && checkedList[i].shopGoodVO.calculateMethod !== '理计/磅计' && checkedList[i - 1].shopGoodVO.calculateMethod !== '理计/磅计') {
      //       this.$commonJs.alertTips({
      //         type: 'success',
      //         title: '成功:',
      //         content: '理计和磅计不能同时结算',
      //         stayTime: 5
      //       })
      //       return
      //     }
      //   }
      //   orderList.push(checkedList[i])
      // }
      // window.localStorage.setItem('baigangOrderList', JSON.stringify(this.myShopList))
      this.$router.push('myOrderDelivery')
    },
    deleteShopCar (item) {
      this.$commonJs.doubleComfirm({
        content: '是否移除该购物车？',
        successFun: msg => {
          this.$axiox.del('/baigang/buyer/center/removeCartGood/' + item.id).then(msg => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '移除成功',
              stayTime: 5
            })
            this.getShopList()
          })
        },
        errorFun: msg => {
        }
      })
    },
    // countNum (type, item) {
    //   if (type === 'reduce') {
    //     if (item.amount > 1) {
    //       item.amount--
    //       this.$axiox.get('/baigang/buyer/center/editCartGoodNum/' + item.id + '?num=' + item.amount)
    //     }
    //   } else {
    //     if (item.amount < item.shopGoodVO.skuList[0].stock) {
    //       item.amount++
    //       this.$axiox.get('/baigang/buyer/center/editCartGoodNum/' + item.id + '?num=' + item.amount)
    //     }
    //   }
    // },
    getShopList () {
      this.$axiox.post('/baigang/app/good/queryCartGoodPage/' + window.localStorage.getItem('memberId'), { currPage: 1, pageSize: 9999 }).then(p => {
        console.log('_______')
        console.log(p)
        this.myShopList = p.data.list.filter(p => { return p.shopGoodVO })
        console.log(this.myShopList)
        for (let i = 0; i < this.myShopList.length; i++) {
          if (parseInt(this.myShopList[i].delFlag) !== 1) {
            this.$set(this.myShopList[i], 'checked', true)
            this.$set(this.myShopList[i], 'shopCarId', this.myShopList[i].id)
          }
        }
        this.$forceUpdate()
        window.localStorage.setItem('baigangOrderList', JSON.stringify(this.myShopList))
      })
    }
  }
}
</script>

<style scoped>
.searchBlock {
  width: 600px;
  height: 40px;
  border: 1px solid #d71e1e;
  border-radius: 4px;
}
.searchBlock input {
  flex: 1;
  height: 100%;
  border: none;
  border-radius: 4px 0px 0px 4px;
  padding: 0 10px;
}
.searchBlock div {
  padding-left: 10px;
  padding-right: 9px;
  height: 100%;
  background: #d71e1e;
  color: #fff;
  font-weight: bold;
  text-align: center;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/myComponents/allMallSerch.vue